namespace TabAurous.Production {
    export interface MFGTransactionLossRow {
        TransLossId?: number;
        TransItemId?: number;
        TransId?: number;
        ProductId?: number;
        BomProductId?: number;
        ProductCode?: string;
        CalcOnId?: number;
        AttributeId?: number;
        Attribute?: string;
        ItemTypeId?: number;
        CertificateNo?: string;
        BagNo?: string;
        LotNo?: string;
        Line_No?: number;
        Pieces?: number;
        Weight?: number;
        Purity?: number;
        PureWeight?: number;
        FromDeptId?: number;
        ToDeptId?: number;
        FromWorkerId?: number;
        ToWorkerId?: number;
        RefVoucherId?: number;
        RefTransId?: number;
        RefTransItemId?: number;
        RefTransBomId?: number;
        IsCustomerItem?: boolean;
    }

    export namespace MFGTransactionLossRow {
        export const idProperty = 'TransLossId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Production.MFGTransactionLoss';
        export const deletePermission = 'Production:MFGTransaction:Delete';
        export const insertPermission = 'Production:MFGTransaction:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:MFGTransaction:Edit';

        export declare const enum Fields {
            TransLossId = "TransLossId",
            TransItemId = "TransItemId",
            TransId = "TransId",
            ProductId = "ProductId",
            BomProductId = "BomProductId",
            ProductCode = "ProductCode",
            CalcOnId = "CalcOnId",
            AttributeId = "AttributeId",
            Attribute = "Attribute",
            ItemTypeId = "ItemTypeId",
            CertificateNo = "CertificateNo",
            BagNo = "BagNo",
            LotNo = "LotNo",
            Line_No = "Line_No",
            Pieces = "Pieces",
            Weight = "Weight",
            Purity = "Purity",
            PureWeight = "PureWeight",
            FromDeptId = "FromDeptId",
            ToDeptId = "ToDeptId",
            FromWorkerId = "FromWorkerId",
            ToWorkerId = "ToWorkerId",
            RefVoucherId = "RefVoucherId",
            RefTransId = "RefTransId",
            RefTransItemId = "RefTransItemId",
            RefTransBomId = "RefTransBomId",
            IsCustomerItem = "IsCustomerItem"
        }
    }
}
